import { SortQueryDirection } from "@ds-cps/ui";

import { OrganizationUserDetailsKeys } from "@organization/models/OrganizationUserDetails";

export class CreateParamsForGetApplications extends URLSearchParams {
  withPagination(pageSize: number, pageIndex?: number) {
    this.append("pageSize", pageSize.toString());

    if (pageIndex !== undefined) {
      this.append("offset", (pageIndex * pageSize).toString());
    }
  }

  withSortBy(activeSort: OrganizationUserDetailsKeys) {
    if (activeSort) {
      this.append("sortBy", activeSort);
    }
  }

  withSortDirection(sortDirection: SortQueryDirection) {
    if (sortDirection) {
      this.append("sortDirection", `${sortDirection}`);
    }
  }
}
